module.exports = __webpack_public_path__ + "img/list-3.84101f85.png";